// import { motion } from "framer-motion";

// export default function AnimatedBg() {
//   return (
//     <div className="fixed inset-0 -z-10 overflow-hidden">
      
//       {/* 🌈 Base Gradient */}
//       <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,#bbf7d0,transparent_40%),radial-gradient(circle_at_80%_80%,#86efac,transparent_40%),#ecfdf5]" />

//       {/* 🌊 Moving Gradient Layer */}
//       <motion.div
//         className="absolute inset-0 opacity-40"
//         animate={{
//           backgroundPosition: ["0% 50%", "100% 50%", "0% 50%"],
//         }}
//         transition={{
//           duration: 25,
//           repeat: Infinity,
//           ease: "linear",
//         }}
//         style={{
//           background:
//             "linear-gradient(270deg, #a7f3d0, #bbf7d0, #d9f99d, #86efac)",
//           backgroundSize: "600% 600%",
//         }}
//       />

//       {/* 🌿 Floating Organic Blobs */}
//       {[...Array(7)].map((_, i) => (
//         <motion.div
//           key={i}
//           className="absolute rounded-full blur-3xl"
//           style={{
//             width: `${200 + i * 40}px`,
//             height: `${200 + i * 40}px`,
//             background:
//               i % 2 === 0
//                 ? "rgba(34,197,94,0.25)"
//                 : "rgba(132,204,22,0.25)",
//           }}
//           initial={{
//             x: Math.random() * window.innerWidth,
//             y: Math.random() * window.innerHeight,
//           }}
//           animate={{
//             y: [0, -120, 0],
//             x: [0, 80, 0],
//           }}
//           transition={{
//             duration: 15 + i * 2,
//             repeat: Infinity,
//             ease: "easeInOut",
//           }}
//         />
//       ))}

//       {/* 🌫 Noise Texture (ULTRA PREMIUM FEEL) */}
//       <div
//         className="absolute inset-0 opacity-10 mix-blend-overlay"
//         style={{
//           backgroundImage:
//             "url('https://grainy-gradients.vercel.app/noise.svg')",
//         }}
//       />
//     </div>
//   );
// }

import { motion, useScroll, useTransform } from "framer-motion";
import { useMemo } from "react";

export default function AnimatedBg() {
  const { scrollY } = useScroll();

  // 🌿 Global transforms
  const xMove = useTransform(scrollY, [0, 1000], ["0%", "20%"]);
  const yMove = useTransform(scrollY, [0, 1000], ["0%", "30%"]);

  // 🌿 ONE transform for blobs (not inside map)
  const blobY = useTransform(scrollY, [0, 1000], [0, -120]);

  // 🎯 Stable random positions (no rerender flicker)
  const positions = useMemo(
    () =>
      [...Array(7)].map(() => ({
        left: `${Math.random() * 80}%`,
        top: `${Math.random() * 80}%`,
      })),
    []
  );

  return (
    <div className="fixed inset-0 -z-10 overflow-hidden">

      {/* 🌈 Dynamic Base Gradient */}
      <motion.div
        className="absolute inset-0"
        style={{
          background: `
            radial-gradient(circle at 20% 20%, #bbf7d0, transparent 40%),
            radial-gradient(circle at 80% 80%, #86efac, transparent 40%),
            #ecfdf5
          `,
          backgroundPosition: `${xMove} ${yMove}`,
        }}
      />

      {/* 🌊 Moving Gradient */}
      <motion.div
        className="absolute inset-0 opacity-40"
        animate={{
          backgroundPosition: ["0% 50%", "100% 50%", "0% 50%"],
        }}
        transition={{
          duration: 25,
          repeat: Infinity,
          ease: "linear",
        }}
        style={{
          background:
            "linear-gradient(270deg, #a7f3d0, #bbf7d0, #d9f99d, #86efac)",
          backgroundSize: "600% 600%",
        }}
      />

      {/* 🌿 Floating Blobs */}
      {positions.map((pos, i) => (
        <motion.div
          key={i}
          className="absolute rounded-full blur-3xl"
          style={{
            width: `${200 + i * 40}px`,
            height: `${200 + i * 40}px`,
            background:
              i % 2 === 0
                ? "rgba(34,197,94,0.25)"
                : "rgba(132,204,22,0.25)",
            left: pos.left,
            top: pos.top,
            y: blobY, // ✅ safe
          }}
          animate={{
            x: [0, 80, 0],
          }}
          transition={{
            duration: 15 + i * 2,
            repeat: Infinity,
            ease: "easeInOut",
          }}
        />
      ))}

      {/* 🌫 Noise */}
      <div
        className="absolute inset-0 opacity-10 mix-blend-overlay"
        style={{
          backgroundImage:
            "url('https://grainy-gradients.vercel.app/noise.svg')",
        }}
      />
    </div>
  );
}